import SurveyListingTable from './surveyListingTable.container'

export default SurveyListingTable